import { apiUrl } from "../lib/api";

export interface Annotation {
  id: number;
  status: "linked" | "undefined";
  label: string;
  termId: number | null;
  box: { x: number; y: number; w: number; h: number } | null;
}

/**
 * Read-only render of a captured doha photo with its on-image
 * annotations drawn as boxes (linked = solid terracotta, undefined =
 * dashed). Chip-only annotations (no box) are shown by the caller.
 */
export function AnnotationOverlay({
  mediaPath,
  annotations,
  onAnnotationClick,
  className,
}: {
  mediaPath: string;
  annotations: Annotation[];
  onAnnotationClick?: (a: Annotation) => void;
  className?: string;
}) {
  const boxed = annotations.filter((a) => a.box);
  return (
    <div className={`relative inline-block ${className ?? ""}`}>
      <img
        src={apiUrl(mediaPath)}
        alt="Captured doha"
        className="block max-w-full rounded-xl"
      />
      {boxed.map((a) => {
        const box = a.box;
        if (!box) return null;
        const linked = a.status === "linked";
        return (
          <button
            key={a.id}
            type="button"
            onClick={() => onAnnotationClick?.(a)}
            title={a.label}
            className="group absolute -m-px cursor-pointer rounded-sm"
            style={{
              left: `${box.x * 100}%`,
              top: `${box.y * 100}%`,
              width: `${box.w * 100}%`,
              height: `${box.h * 100}%`,
              border: linked ? "2px solid #c15f3c" : "2px dashed #c15f3c",
              background: "rgba(193, 95, 60, 0.08)",
            }}
          >
            <span className="pointer-events-none absolute left-0 top-full mt-0.5 hidden whitespace-nowrap rounded bg-ink px-1.5 py-0.5 font-serif text-xs text-paper group-hover:block">
              {a.label}
              {!linked ? " · needs a definition" : ""}
            </span>
          </button>
        );
      })}
    </div>
  );
}
